var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 footer-copyright text-left"},[_c('span',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.$t("lbl_EMPBE_Footer_Tips",{currentYear:_vm.year})))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }